import { QueryClient } from '@tanstack/react-query';

/**
 * Shared React Query client. Exported from a standalone module (not `main.tsx`)
 * so non-React callers — e.g. the SignalR portal-message dispatcher — can
 * invalidate cached queries (`rumRolesForProfile`, `app-tiles`) in reaction to
 * live role/screen updates without importing the bootstrap entrypoint.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});
